import { atom } from 'jotai'

const email = atom<string | null>(null)
export const passwordForgetEmailStore = { email } as const
